import { useTheme } from "@mui/material";
import {
  CategoryScale,
  Chart,
  Title,
  Tooltip,
  LinearScale,
  LineElement,
  PointElement,
} from "chart.js";
import React from "react";
import { Line } from "react-chartjs-2";

Chart.register(Title, Tooltip, CategoryScale, LinearScale, LineElement, PointElement);

interface Props {
  labels: string[];
  data: number[];
}

const LineChart = ({ labels, data }: Props) => {
  const theme = useTheme();
  return (
    <Line
      options={{
        responsive: true,
        plugins: {
          legend: {
            position: "top" as const,
            display: false,
          },
        },
        scales: {
          y: {
            min: 0,
            grace: "10%",
          },
        },
        animations: {
          tension: {
            duration: 1000,
            easing: "linear",
            from: 1,
            to: 0,
          },
        },
      }}
      data={{
        labels,
        datasets: [
          {
            data,
            label: "test",
            borderColor: theme.palette.primary.main,
            backgroundColor: theme.palette.primary.main,
            tension: 0.1,
          },
        ],
      }}
    />
  );
};

export default LineChart;
